import { Controller } from "@hotwired/stimulus"

// Numeric stepper for form fields. Two buttons (− / +) drive a display
// span AND a hidden input that the surrounding form submits. Replaces
// `<input type="number">` on touch devices where typing a number means
// summoning the keyboard for one digit.
//
// Markup contract:
//   <div data-controller="stepper"
//        data-stepper-min-value="0" data-stepper-step-value="5">
//     <button data-action="stepper#decrement">−</button>
//     <span data-stepper-target="display">0</span>
//     <button data-action="stepper#increment">+</button>
//     <input data-stepper-target="input" type="hidden" name="..." value="0">
//   </div>
export default class extends Controller {
  static targets = ["display", "input"]
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 9999 },
    step: { type: Number, default: 1 }
  }

  increment() {
    this.set(this.current + this.stepValue)
  }

  decrement() {
    this.set(this.current - this.stepValue)
  }

  set(value) {
    const clamped = Math.min(this.maxValue, Math.max(this.minValue, value))
    this.displayTarget.textContent = clamped
    if (this.hasInputTarget) this.inputTarget.value = clamped
  }

  get current() {
    return parseInt(this.inputTarget?.value, 10) || parseInt(this.displayTarget.textContent, 10) || this.minValue
  }
}
